var link_viewer_default = {
  "fontElementMap": "vkuMn",
  "link": "b945p",
  "linkInEditor": "VRmDN",
  "linkInViewer": "zPJV4",
  "toolbarUrlContainer": "_7wKpR",
  "toolbarUrl": "dBwDJ",
  "toolbarUrlAnchor": "jGaKm"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
